<template>
	<div class="overflow-x-hidden">
		<div class="mt-20 max-w-max mx-auto">
			<h1 class="font-gilroy-extrabold text-5xl text-black text-center">
				System status
			</h1>

			<span class="mt-12 max-w-2xl text-center block mx-auto text-inter-400 text-gray-500 text-lg"> 
				We always improve our infrastructure in order to ensure the best services.<br>
			</span>
		</div>
		<div class="max-w-7xl mx-auto">
			<div class="shadow max-w-2xl mx-auto overflow-hidden border-b mt-6 border-gray-200 sm:rounded-lg">
				<table class="min-w-full table-auto overflow divide-y divide-gray-200">
					<thead class="bg-gray-50">
						<tr>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Name
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Type
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Provider
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Status
							</th>
						</tr>
					</thead>
					<tbody class="bg-white divide-y divide-gray-200">
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Gonomos Server
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Maintenance
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								MX Server
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Hosting
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://mxhost.ro" class="text-blue-500">MXHost</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								ADMIN Server
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Hosting
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://admin.ro" class="text-blue-500">Gazduire.NET</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Rookie Server
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Development
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<span class="mt-12 max-w-2xl text-center block mx-auto text-inter-400 text-gray-500 text-lg"> 
				Modules<br>
			</span>

			<div class="shadow max-w-2xl mx-auto overflow-hidden border-b mt-6 border-gray-200 sm:rounded-lg">
				<table class="min-w-full divide-y divide-gray-200">
					<thead class="bg-gray-50">
						<tr>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Name
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Type
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Provider
							</th>
							<th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Status
							</th>
						</tr>
					</thead>
					<tbody class="bg-white divide-y divide-gray-200">
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Error tracking
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Maintenance
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Database health
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Maintenance
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Uptime monitor
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Maintenance
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
						<tr>
							<td class="px-6 py-4 whitespace-nowrap">
								Performance check
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								Maintenance
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<a href="https://codestage.ro" class="text-blue-500">Codestage</a>
							</td>
							<td class="px-6 py-4 whitespace-nowrap">
								<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
									Active
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<Contact />
	</div>
</template>

<script>

import Contact from '@/components/Contact'

export default {
	components: {
		Contact
	}
}
</script>